import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneMatchListGroupPayload } from '@app-store/slices/matchListGroups/oneMatchListGroup'

interface TaskAction extends Action {
    payload: IOneMatchListGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchListGroups.oneMatchListGroup

function* getOneMatchListGroupTask({ payload }: TaskAction) {
    

    try {
        const response = yield axios.get(`/companies/match-list-groups/one/${payload.matchListGroupId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getOneMatchListGroup(): any {
    yield takeLatest<TaskAction>(onRequest, getOneMatchListGroupTask)
}

export default getOneMatchListGroup
